import type { Element } from 'hast';
import { Params } from 'react-router-dom';
export function getHeadingElementId(ele: Element, ids: Record<string, number>) {
    const id = ele.children?.[0]?.type === 'text' ? ele.children[0].value : undefined;
    if (! id) {
        return id;
    }
    const validId = id.replace(/\./g, '').replace(/\s+/g, '-').toLowerCase();
    const idx = (ids[validId] !== undefined) ? (++ ids[validId]) : (ids[validId] = 0);
    return idx ? `${validId}-${idx}` : validId;
}
